exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".language-container {\n  display: flex; }\n\n.flag {\n  width: 30px;\n  margin-left: 10px;\n  opacity: 0.5; }\n\n.flag-active {\n  width: 30px;\n  margin-left: 10px;\n  opacity: 1; }\n\n.flag:hover {\n  opacity: 1;\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/Shared/LanguagePicker/LanguagePicker.scss
// module id = 1460
// module chunks = 0